import { useCallback } from "react";
import { formatCurrency, sanitizeNumberInput } from "../../../../utils/format";

// New: currency formatter that writes into RHF via setValue.
// Signature: useCurrencyFormat(setValue)
export const useCurrencyFormat = (setValue) => {
  const handleCurrencyBlur = useCallback(
    async (field, current) => {
      // Prefer the explicit `current` value provided by callers (ControlledField passes it).
      const raw = String(current ?? "").trim();
      const cleaned = sanitizeNumberInput(raw, "");
      const formatted = cleaned ? formatCurrency(cleaned) : "";

      if (typeof setValue === 'function') {
        try {
          // write formatted value back into RHF and also return it for callers
          setValue(field, formatted);
          return formatted;
        } catch (e) {
          console.warn('useCurrencyFormat: setValue failed', e);
        }
      }

      // If no setValue available, simply return the formatted string so callers can use it.
      return formatted;
    },
    [setValue]
  );

  return handleCurrencyBlur;
};

